/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
import { getQueryParam } from '../routing/getQueryParam';
export const checkUrlForUUID = () => {
  return Boolean(getQueryParam('uuid'));
};
export const hasAnonQueryParam = () => {
  const anonParam = getQueryParam('anon');
  return anonParam && anonParam === 'true';
};